import { Dialog } from "@material-ui/core";
import React from "react";
import { LottiePlayer } from "./LottiePlayer";
import AIExample from "./assets/ai-example";

export const AIModal = ({
  primaryAction,
  secondaryAction,
  primaryActionText,
  secondaryActionText,
  footer,
  title,
  description,
}: {
  primaryAction: () => void;
  secondaryAction: () => void;
  primaryActionText: string;
  secondaryActionText: string;
  title: string;
  description: string;
  footer?: JSX.Element;
}) => {
  return (
    <Dialog
      PaperProps={{
        style: {
          borderRadius: 12,
        },
      }}
      aria-labelledby="disabled-dialog-title"
      open
    >
      <div
        className="cw-overflow-none cw-flex cw-flex-col cw-items-center"
        style={{ width: 570, background: "#4459DD" }}
      >
        <div className="cw-p-6">
          <LottiePlayer
            autoplay
            loop
            src={AIExample}
            className="cw-border cw-border-[rgba(0,63,46)] cw-border-solid cw-rounded-lg cw-h-[250px] xl:cw-h-[300px] cw-w-auto cw-drop-shadow-[3px_3px_0px_rgba(0,63,46)]"
          />
        </div>
        <div className="cw-flex cw-flex-col cw-space-y-1 cw-px-11">
          <div
            id="disabled-dialog-title"
            className="cw-heading-base cw-text-2xl cw-text-center cw-text-onEmphasis"
          >
            {title}
          </div>
          <div className="cw-body-base cw-text-onEmphasis cw-text-center">{description}</div>
          <div className="cw-py-5 cw-px-[30px]">
            <button
              cw-id="ai-modal-primary-button"
              className="cw-bg-default cw-border-none cw-h-9 cw-w-full cw-text-busy cw-flex cw-justify-center cw-items-center cw-body-base cw-font-semibold cw-px-3 cw-rounded-lg cw-cursor-pointer hover:cw-bg-default-hover"
              onMouseDown={primaryAction}
            >
              {primaryActionText}
            </button>
            <button
              cw-id="ai-modal-primary-button"
              className="cw-border-none cw-bg-transparent cw-h-9 cw-w-full cw-text-onEmphasis hover:cw-text-onEmphasis-hover focus:cw-text-onEmphasis-focus cw-flex cw-justify-center cw-items-center cw-body-base cw-font-semibold cw-px-3 cw-rounded-lg cw-cursor-pointer "
              onMouseDown={secondaryAction}
            >
              {secondaryActionText}
            </button>
          </div>
        </div>
        <div className="cw-flex cw-flex-col cw-px-6 cw-pb-7">{footer}</div>
      </div>
    </Dialog>
  );
};
